<template>
  <v-text-field
    :value="value"
    :label="label"
    :rules="rules"
    @change="$emit('update:value', $event.target.value)"
    @keyup="$emit('update:value', $event.target.value)"
    validate-on-blur
  ></v-text-field>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      defaultEmailRules: [],
    };
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mergedRules() {
      return [...this.rules, ...this.defaultEmailRules];
    },
  },
});
</script>
